import $ from 'jquery';
import { matchesCriteria } from '../utils/criteria';
import { getInputValue } from '../utils/input';
const ELEMENT_SELECTOR = '.js__change-label-on-value';
export class ChangeLabelOnValue {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.on('change', e => {
            this.initLabelChanges($(e.currentTarget));
        });
        $element.each((index, element) => {
            this.initLabelChanges($(element));
        });
    }
    static initLabelChanges($element) {
        const { criteriaValue, newLabelInverseCriteria, newLabel, newLabelTarget } = $element.data();
        const $label = $(newLabelTarget).parent().find('label');
        if (matchesCriteria(criteriaValue, getInputValue($element), newLabelInverseCriteria)) {
            $label.data('old-label', $label.html());
            $label.html(newLabel);
        }
        else {
            $label.html($label.data('old-label'));
        }
    }
}
